import React, { useState } from "react";
import { InternationalCallingPlanTable } from "./plan-table";

import { Input } from "app/components/ui/input";

export const InternationalCallingPlan = () => {
  const [searchValue, setSearchValue] = useState("");

  const handleSearchChange = (value: string) => {
    setSearchValue(value);
  };

  return (
    <section className="px-5 sm:px-6 md:px-7 lg:px-9 xl:px-12 pb-9 sm:pb-14 md:pb-[5.5rem] lg:pb-[7.5rem]">
      <div className="w-full max-w-[82.375rem] mx-auto">
        <div className="mb-4 text-center sm:mb-5 md:mb-6 lg:mb-8">
          <h2 className="font-mobile text-[#1D1D1B] text-[clamp(1.5rem,calc(2.5vw+1rem),3.125rem)] font-normal leading-snug md:leading-normal lg:leading-[5.25rem] mb-0.5">
            Free Calls to 170+ Countries
          </h2>
          <p className="text-[#1A0F33] text-[0.925rem] sm:text-base lg:text-lg font-normal leading-5 sm:leading-6 lg:leading-7">
            Check out the ILD destinations included with all our plans
          </p>
        </div>
        <div className="bg-white border border-[#E9EAEB] rounded-xl shadow-[0px_1px_2px_0px_rgba(10,13,18,0.05)] overflow-hidden">
          <div className="flex justify-between sm:items-center gap-2 p-3 sm:px-6 sm:py-4 md:px-7 md:py-5 lg:pl-[2.125rem] lg:pr-[2.05rem] lg:py-[1.375rem]">
            <h2 className="hidden sm:block text-base font-medium leading-5 text-[#181D27] font-mobile sm:text-lg lg:text-xl 2xl:text-2xl sm:leading-6 lg:leading-7">
              International Long Distance
            </h2>
            <div className="relative w-full sm:w-auto">
              <div className="absolute left-2 sm:left-2.5 lg:left-3 top-1/2 -translate-y-1/2">
                <img
                  src="/assets/search-normal.webp"
                  alt="Search"
                  className="size-3.5 sm:size-4 lg:size-5"
                />
              </div>
              <Input
                type="text"
                value={searchValue}
                onChange={(e) => handleSearchChange(e.target.value)}
                className="sm:w-60 md:w-80 lg:w-[31.1875rem] h-9 sm:h-10 lg:h-11 py-2 px-7 sm:py-2.5 sm:px-8 lg:py-3 lg:px-[2.4375rem] border border-[#DBDBDB] rounded-[0.625rem] text-black placeholder:opacity-50 text-[0.775rem] sm:text-[0.8125rem] font-normal leading-normal focus-visible:outline focus:outline-[#707C8F]"
                placeholder="Search Destinations..."
              />
              {searchValue && (
                <div className="absolute right-2 sm:right-2.5 lg:right-3 top-1/2 -translate-y-1/2">
                  <img
                    src="/assets/close.svg"
                    alt="Search"
                    className="size-3.5 sm:size-4 lg:size-5 cursor-pointer opacity-50 hover:opacity-100"
                    onClick={() => setSearchValue("")}
                  />
                </div>
              )}
            </div>
          </div>
          <InternationalCallingPlanTable searchValue={searchValue} />
        </div>
      </div>
    </section>
  );
};
